const displayDays = (days) => `${days} ${days > 1 ? window?.i18n?.t('days') : window?.i18n?.t('day')}`;

export default displayDays;